import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { BaseEntityResponseDto } from '@sphere/shared/domain'
import { ActivityVisibility } from '../../../enums'
import { TemplateCapabilities } from '../../../interfaces/template-capabilities.interface'

export class TemplateListItemResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  name!: string

  @ApiPropertyOptional({ type: 'string', nullable: true })
  description!: string | null

  @ApiProperty({ type: 'string' })
  typeId!: string

  @ApiProperty({ enum: ActivityVisibility })
  visibility!: ActivityVisibility

  @ApiProperty({ type: 'string' })
  ownerUserId!: string

  @ApiPropertyOptional({ description: 'Permissions calculées', type: Object })
  capabilities?: TemplateCapabilities
}
